import { api } from './utils';

export async function fetchAllTrades(smartContractWalletAddress: string) {
	if (!smartContractWalletAddress) return;

	const response = await api('get', `snx-perps/users/${smartContractWalletAddress}/trades`);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchTradesPaginated(
	page: number,
	pageSize: number,
	smartContractWalletAddress: string
) {
	if (!smartContractWalletAddress) return;

	const response = await api(
		'get',
		`snx-perps/users/${smartContractWalletAddress}/trades/v2?page=${page}&pageSize=${pageSize}`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchAllPositions(smartContractWalletAddress: string) {
	if (!smartContractWalletAddress) return;

	const response = await api('get', `snx-perps/users/${smartContractWalletAddress}/positions`);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchAllOrders(smartContractWalletAddress: string) {
	if (!smartContractWalletAddress) return;

	const response = await api(
		'get',
		`snx-perps/users/${smartContractWalletAddress}/orders?statuses=Pending&statuses=Expired&statuses=Submitted&statuses=FirstExecuted&statuses=Submitted`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchAllOrderHistory(smartContractWalletAddress: string) {
	if (!smartContractWalletAddress) return;
	const response = await api(
		'get',
		`snx-perps/users/${smartContractWalletAddress}/orders?statuses=Pending&statuses=Filled&statuses=Executed&statuses=Cancelled&statuses=Expired`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchPaginatedOrderHistory(
	page: number,
	pageSize: number,
	smartContractWalletAddress: string
) {
	if (!smartContractWalletAddress || !page || !pageSize) return;
	const response = await api(
		'get',
		`snx-perps/users/${smartContractWalletAddress}/orders/v2?` +
			`statuses=Pending&statuses=Filled&statuses=Executed&statuses=Cancelled&statuses=Expired&statuses=Completed&statuses=FirstExecuted` +
			`&page=${page}&pageSize=${pageSize}`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
